import React from 'react';

import './Blog.css';

const blogData = [
    {
        title: 'The Complete Guide to SEO in 2025',
        description: 'Everything you need to know about modern SEO practices, from technical optimization to content strategy and link building.'
    },
    {
        title: 'Maximizing ROI with Google Ads',
        description: 'Learn how to optimize your Google Ads campaigns for maximum conversions while minimizing cost per acquisition.'
    },
    {
        title: 'Web Design Trends That Convert',
        description: 'Discover the latest web design trends that not only look great but also drive user engagement and conversions.'
    }
];

const Blog = () => {
    return (
        <section className="blog" id="blog">

            <div className="container">
                <div className="label">Latest Resources</div>
                <div className="blog-grid">
                    {blogData.map((post, index) => (
                        <div className="blog-card" key={index}>
                            <div className="blog-image">
                                {/* IMAGE PLACEHOLDER: Add blog post featured image here (recommended size: 400x250px) */}
                                <div className="image-placeholder-text">🖼️ Add Blog Image {index + 1}</div>
                            </div>
                            <div className="blog-content">
                                <h3>{post.title}</h3>
                                <p>{post.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Blog;
